import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { makeStyles } from '@mui/styles'
import lang from 'lang'
import { ButtonIconSquare } from '@/modules/base/components/buttons/index'
import { FinanceFormKeys } from '@/modules/document-export/constants'
import DatevView from '@/modules/apps/own/datev/components/datev-view'
import DatevService from '@/modules/apps/own/datev/datevService'
import datevConfig from '@/modules/apps/own/datev/config'
import { fetchApps, installApp } from '@/redux/ducks/apps'
import { Title, SubTitle } from '@/modules/base/components/texts'
import HorizontalRuler from '@/modules/base/components/ruler/horizontal-ruler'
import { urls } from '@/modules/document-export/config'
import request from '@/modules/base/util/request'

import PlusIcon from '@assets/images/apps/plus.svg'
import DatevIcon from '@assets/images/tax-export-logos/datev.svg'
import CloudUploadIcon from '@assets/images/icons/cloud_upload2.svg'
import SvgIcon from '@/modules/base/components/svg-icon/svg-icon'

const useStyles = makeStyles((theme) => ({
  buttonContainer: {
    display: 'flex',
    justifyContent: 'end',
    paddingTop: 30,
  },
  subTitle: {
    lineHeight: '1.86',
    color: theme.black,
    marginBottom: 0,
  },
  faq: {
    marginTop: 5,
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}))

const DocumentExportFormDatevView = (props) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { showApp, apps } = useSelector(state => state.apps)
  const [connectionStatus, setConnectionStatus] = useState({})
  const [appData, setAppData] = useState({})
  const [datevAppData, setDatevAppData] = useState({})
  const DATEV_CALLBACK_URL = '/apps/datev'

  useEffect(() => {
    dispatch(fetchApps({ path: 'all' }))
    dispatch(fetchApps({ path: 'own' }))
    Promise.all([
      request(datevConfig.endpoints.authStatus, { auth: true, isConcurrent: true }),
      DatevService.getAppSettings(),
    ]).then(([response, appData]) => {
      const { data } = response.body
      setConnectionStatus(data)
      setAppData(appData)
    })
  }, [])

  useEffect(() => {
    const datevApp = apps?.all?.find(app => app.callbackUrl === DATEV_CALLBACK_URL)
    setDatevAppData(datevApp)
  }, [apps])

  return (
    <>
      <div className={classes.titleContainer}>
        <Title icon={CloudUploadIcon}>{lang.documentExport.forms.exportDatevView.title}</Title>
        <SvgIcon svg={DatevIcon} height={30} width={32} />
      </div>
      <SubTitle className={classes.subTitle}>{lang.documentExport.forms.exportDatevView.subTitle}</SubTitle>
      <p className={classes.faq}>
        {lang.documentExport.forms.exportDatevView.faqLabel}{' '}
        <a href={urls.datevFaq} target='__blank' className={classes.faqLink}>{lang.documentExport.forms.exportDatevView.faqLink}</a>
      </p>
      {(showApp?.isInstalled || connectionStatus?.connected || apps?.own?.find(app => app.callbackUrl === DATEV_CALLBACK_URL))
        ? (
          <>
            <HorizontalRuler />
            <DatevView
              appId={showApp?.appId || datevAppData?.appId}
              documentTitle={lang.documentExport.forms.exportDatevView.documentTitle}
              initAppData={appData}
              initConnectionStatus={connectionStatus}
              isDocumentExport={true}
            />
          </>
        )
        : (
          <div className={classes.buttonContainer}>
            <ButtonIconSquare
              icon={PlusIcon}
              onClick={() => {
                dispatch(installApp(showApp?.appId ? showApp : datevAppData))
              }}
              label={lang.documentExport.forms.exportDatevView.buttonTitle}
            />
          </div>
        )
      }
    </>
  )

}

DocumentExportFormDatevView.financeFormKey = FinanceFormKeys.exportDatevView

export default DocumentExportFormDatevView
